<template>
	<div class="reservations-body">
		<AppPagination no-navigation-buttons hide-dots hide-header change-height :pages="pages" ref="multi-menu-pagination" :page-index="initialPageIndex">
			<template v-slot:reservations="{item}">
				<div class="menus-container">
					<SingleExperience :experience-id="experience.experience_id" @click="ev => clickExperience(ev, experience)" v-for="experience in reservationsStore.experiencesAvailable" :ref="'single-experience-'+experience.experience_id" :key="experience.experience_id" v-if="reservationsStore.experiencesAvailable.length > 0" />
					<div class="no-menus-container" v-else>
						<div class="no-menus">
							<div class="no-menus-title">{{ getString('no_experiences_available') }}</div>
							<div class="no-menus-image"></div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:single-reservation="{item}">
				<div class="single-reservation" v-if="reservationsStore.selectedExperienceId">
					<ExperienceBooker />
				</div>
			</template>
		</AppPagination>
	</div>
</template>

<script>
import {useReservationsStore} from "@/book/stores";
import AppPagination from "@/shared/components/AppPagination.vue";
import SingleMenu from "@/new-menu/components/SingleMenu.vue";
import {useLanguageStore} from "@/shared/stores";
import SingleExperience from "@/book/components/SingleExperience.vue";
import MenuCategory from "@/new-menu/components/MenuCategory.vue";
import ExperienceBooker from "@/book/components/ExperienceBooker.vue";

export default {
	setup() {
		const reservationsStore = useReservationsStore();
		const languageStore = useLanguageStore();
		return {reservationsStore, getString: languageStore.getString};
	},
	components: {MenuCategory, SingleMenu, AppPagination, SingleExperience, ExperienceBooker},
	name: "ReservationsBody",
	data() {
		return {
			pages: [
				{id: 'reservations', slotName: 'reservations'},
				{id: 'single', slotName: 'single-reservation'},
			],
			initialPageIndex: 0
		}
	},
	methods: {
		clickExperience(ev, experience) {
			let experienceSlug = experience.slug ? experience.slug : experience.experience_id;
			this.$router.push("/" + experienceSlug + "/");
		}
	},
	mounted() {
		if(this.$route.params.experienceId) {
			this.$refs['multi-menu-pagination'].changeSlide(1, false);
		}
	},
	watch: {
		$route(to, from) {
			if (to.params.experienceId === from.params.experienceId) {
				return;
			}
			if (to.params.experienceId) {
				this.$refs['multi-menu-pagination'].changeSlide(1);
				let experienceSlug = to.params.experienceId;
				let experience = this.reservationsStore.experiencesAvailable.find(experience => experience.slug === experienceSlug);
				experience = experience ? experience : this.reservationsStore.experiencesAvailable.find(experience => experience.experience_id === Number(experienceSlug));
				if (experience) {
					this.reservationsStore.chosenDate = null;
					this.reservationsStore.chosenTime.time = null;
					this.reservationsStore.chosenTime.slotId = null;
					this.reservationsStore.chosenTime.maxPeople = null;
					this.reservationsStore.chosenPeople = null;

					this.reservationsStore.goToMenu(experience.experience_id);
				}
			} else {
				this.$refs['multi-menu-pagination'].changeSlide(0);
				this.reservationsStore.backToMultimenu();
			}
		},
	}
}
</script>

<style scoped lang="scss">
.reservations-body {

	.menus-container {
		display: flex;
		flex-wrap: wrap;
		gap: var(--padding-vertical);
		margin-top: var(--padding-vertical);
		padding: var(--padding-vertical) var(--padding-horizontal);
	}

	.no-menus-container {
		width: 100%;
		display: flex;
		align-items: center;

		&.no-menus-container-categories {
			margin-top: var(--padding-vertical);
		}

		.no-menus {
			height: 80px;
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
			border-radius: var(--rounded-corner);
			overflow: hidden;

			.no-menus-title {
				width: calc((100% / 3) * 2);
				height: 100%;
				display: flex;
				align-items: center;
				padding: var(--padding-vertical) var(--padding-horizontal);
				text-align: left;
				font-size: var(--font-size-l);
				line-height: var(--line-height-l);
				font-weight: 500;
				color: var(--business-color);
				background-color: var(--theme-bg2-color);
				position: relative;


				&:before {
					content: '';
					height: 100%;
					display: block;
					background: inherit;
					position: absolute;
					top: 0;
					right: -17px;
					width: 36px;
					border-radius: var(--rounded-corner);
					transform: skewX(-10deg) translateX(0px);
					z-index: -1;
				}
			}

			.no-menus-image {
				width: calc(100% / 3);
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: var(--theme-bg2-alpha40-color);
			}
		}

	}
}
</style>